// =============================================================================
// features/sales/contacts/labels.ts — Rótulos pt-BR de `ContactChannel`,
// locais a este módulo (F34-S05).
//
// Duplicado (em escala mínima) de `features/sales/agenda/labels.ts` — aquele
// arquivo está fora de `files_allowed` deste slot (dono: F33-S05/S06), mesma
// convenção já usada por `features/crm/CrmDetailPage.tsx`
// (`APPOINTMENT_CHANNEL_LABELS`) e `hooks/crm/useLeadAppointments.ts`. Se o
// rótulo mudar, as cópias precisam mudar juntas.
// =============================================================================

import type { ContactChannel } from '@elemento/shared-schemas';

export const CHANNEL_LABELS: Record<ContactChannel, string> = {
  phone_manual: 'Ligação',
  phone_integrated: 'Ligação (telefonia)',
  whatsapp: 'WhatsApp',
  in_person: 'Presencial',
  other: 'Outro',
};
